export type WorkflowSection = "steps" | "preview" | "details";

export type WorkflowStepType =
    | "PICTURE"
    | "RECORD_VIDEO"
    | "READ_QR_CODE"
    | "INSTRUCTIONS"
    | "VALIDATE_QR_CODE"
    | "INSTRUCTIONS_WITH_IMAGE"
    | "COMMENT";

export interface WorkflowOwner {
    username?: string;
    userDetails?: {
        firstName?: string;
        familyName?: string;
    };
}

export interface ManagedWorkflow {
    gmvid: string;
    objectId: string;
    company: string;
    title: string;
    team: string;
    steps: string[];
    owner: string | null;
    ownerInfo: WorkflowOwner | null;
}

export interface WorkflowStep {
    gmvid: string;
    objectId: string;
    idUsedWhenFetching: string;
    company: string;
    team: string;
    title: string;
    shortInstruction: string;
    longInstruction: string;
    pictureURL: string;
    codeToScan: string;
    stepSort: WorkflowStepType;
}

export interface WorkflowStepDraft {
    stepSort: WorkflowStepType;
    shortInstruction: string;
    longInstruction: string;
    qrCode: string;
    existingPictureUrl: string;
    file: File | null;
}

export type WorkflowMutationType =
    | "create"
    | "rename"
    | "update-owner"
    | "delete"
    | "create-step"
    | "update-step"
    | "delete-step"
    | "reorder-steps";

export interface WorkflowMutationState {
    type: WorkflowMutationType;
    status: "pending" | "success" | "error";
}

export const WORKFLOW_STEP_TYPES: readonly WorkflowStepType[] = [
    "INSTRUCTIONS",
    "INSTRUCTIONS_WITH_IMAGE",
    "PICTURE",
    "RECORD_VIDEO",
    "READ_QR_CODE",
    "VALIDATE_QR_CODE",
    "COMMENT",
];

export function workflowStepCode(draft: WorkflowStepDraft): string {
    switch (draft.stepSort) {
        case "PICTURE":
            return "--takepicture--";
        case "RECORD_VIDEO":
            return "--recordvideo--";
        case "READ_QR_CODE":
            return "--any--";
        case "VALIDATE_QR_CODE":
            return draft.qrCode;
        default:
            return "";
    }
}
